// 采集卡片瀑布流的图片最大高度
export const PIN_CARD_MAX_HEIGHT: number = 520;